import React from 'react';

interface CzechFlagIconProps {
  className?: string;
}

function CzechFlagIcon({ className }: CzechFlagIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 512 512" className={className}>
      <path fill="#fff" d="M0 0h512v256H0z" />
      <path fill="#d7141a" d="M0 256h512v256H0z" />
      <path fill="#11457e" d="M300 256 0 56v400z" />
    </svg>
  );
}

export default CzechFlagIcon;
